import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

const faqs = [
    {
        question: "What is Bluesky Analytics?",
        answer: "Bluesky Analytics refers to tools like Bluesky Insights that provide detailed metrics and insights about activity on Bluesky profiles, including engagement rates, follower trends, and posting patterns."
    },
    {
        question: "Does Bluesky have analytics?",
        answer: "Bluesky does not offer built-in analytics. However, tools like Bluesky Insights provide comprehensive analytics for Bluesky profiles, including engagement graphs, word clouds, and hourly posting trends."
    },
    {
        question: "How can I analyze my Bluesky profile?",
        answer: "You can analyze your Bluesky profile using Bluesky Insights. Enter your Bluesky handle to view follower stats, average likes, reposts, and other engagement metrics."
    },
    {
        question: "What is Bluesky social profile analysis?",
        answer: "Bluesky social profile analysis involves examining the performance of a Bluesky profile using tools like Bluesky Insights. It includes metrics like total posts, engagement rates, and popular topics based on a word cloud."
    },
    {
        question: "What insights can I get from Bluesky analytics tools?",
        answer: "Tools like Bluesky Insights provide detailed reports on follower growth, post engagement, popular posting times, and frequently used words in posts."
    },
    {
        question: "Are there free tools for Bluesky analytics?",
        answer: "Yes, Bluesky Insights is a free tool that provides in-depth analytics for any Bluesky profile without requiring signups or subscriptions."
    },
    {
        question: "Why should I use Bluesky analytics?",
        answer: "Bluesky analytics can help you understand engagement trends, optimize your posting strategy, and identify topics that resonate with your audience on the platform."
    },
    {
        question: "Can I track engagement rates on Bluesky profiles?",
        answer: "Yes, Bluesky Insights calculates engagement rates by analyzing metrics like average likes, replies, reposts, and quotes over a given time frame."
    },
    {
        question: "How is Bluesky Insights different from other analytics tools?",
        answer: "Bluesky Insights is specifically tailored for Bluesky profiles, offering unique features like colorful word clouds and detailed hourly posting trends, in addition to traditional engagement metrics."
    },
    {
        question: "Does Bluesky provide tools for social media analysis?",
        answer: "Bluesky does not natively provide analysis tools, but third-party tools like Bluesky Insights fill the gap with advanced profile analytics."
    },
    {
        question: "What is the real-time hashtag leaderboard?",
        answer: "The real-time hashtag leaderboard tracks and ranks the most popular hashtags on Bluesky as they appear in new posts. It updates dynamically, showing trending topics in real-time. Hashtags are case-insensitive, and a safe mode filter is available to remove inappropriate content."
    }
];

export function FAQ() {
    return (
        <section className="w-full max-w-3xl mx-auto py-12 px-4">
            <h3 className="text-2xl  font-semibold p-2 rounded-full max-w-lg mx-auto flex items-center gap-1 justify-center">
                Frequently Asked Questions
            </h3>
            <Accordion type="single" collapsible className="w-full">
                {faqs.map((faq, index) => (
                    <AccordionItem key={index} value={`item-${index}`}>
                        <AccordionTrigger>{faq.question}</AccordionTrigger>
                        <AccordionContent>{faq.answer}</AccordionContent>
                    </AccordionItem>
                ))}
            </Accordion>
        </section>
    )
}
